import { getBorderRadius } from '$lib/global/helper/border-radius';
import { getColorByLightness, hexToRgb, isHexString } from '$lib/helper';

import { isUsableColor } from '../../_utils/color';

import type { BrandBorderRadius, Theme } from '$lib/types/Theme';

export interface ResolvedVideoAnswerStyling {
    bgColor: string | undefined;
    borderColorStyle: string | undefined;
    borderRadiusClass: string;
    textColor: string;
}

interface Params {
    theme: Theme;
    bgColor: string;
    color: string;
}

const toRgba50 = (color: string): string => {
    if (!isHexString(color)) {
        return color;
    }

    const { r, g, b } = hexToRgb(color);

    return `rgba(${r}, ${g}, ${b}, 0.5)`;
};

const resolveBgColor = (theme: Theme, perAnswer: string): string | undefined => {
    const isThemeV2 = !!theme?.surface;

    if (isUsableColor(perAnswer)) {
        return perAnswer;
    }

    if (isThemeV2 && theme.secondary) {
        return toRgba50(theme.secondary);
    }

    return undefined;
};

const resolveTextColor = (theme: Theme, perAnswer: string, cardBg: string | undefined): string => {
    const isThemeV2 = !!theme?.surface;

    if (isUsableColor(perAnswer)) {
        return perAnswer;
    }

    if (isThemeV2 && theme.fontColor) {
        return theme.fontColor;
    }

    return getColorByLightness(cardBg ?? 'black');
};

export const resolveVideoAnswerStyling = ({
    theme,
    bgColor,
    color,
}: Params): ResolvedVideoAnswerStyling => {
    const resolvedBgColor = resolveBgColor(theme, bgColor);

    return {
        bgColor: resolvedBgColor,
        borderColorStyle: theme.border || undefined,
        borderRadiusClass: getBorderRadius(
            'choiceItem',
            theme.borderRadius as BrandBorderRadius | undefined,
        ),
        textColor: resolveTextColor(theme, color, resolvedBgColor),
    };
};
